// console.log('resources/assets/js/api/user_status.js');
/*
    Imports the Cockpit API URL from the config.
*/
import { API_CONFIG } from '../config.js';

export default {
	/* GET /api/v1/user_status */
	getUserStatus: function () {
		return axios.get(API_CONFIG.API_URL + '/user_status');
	},

	putEditUser: function (user) {
		return axios.put(API_CONFIG.API_URL + '/user_status/' + user.uuid, user);
	}
};
